import { Button, Modal } from "antd";
import API from "API";
import RichEditor from "components/general/RichEditor";
import React, { useCallback, useState } from "react";
import toastr from "toastr";
function ActionPostNewsFeed({ visible, setVisible, id, getDataPost }) {
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState({
        text: "",
        images: [],
    });

    const postNewsFeed = useCallback(async () => {
        try {
            setLoading(true);
            if (!value?.text && !value?.images.length) {
                toastr.warning("Nội dung chưa có gì để tạo bài");
                return;
            }
            const formData = new FormData();
            formData.append("course", id);
            formData.append("content", value?.text);
            for (const image of value?.images) {
                formData.append("images", image.originFileObj);
            }
            const response = await API.post("/student/posts/", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data) {
                toastr.success("Thêm bài đăng thành công");
                setVisible(false);
                getDataPost();
                setValue({ text: "", images: [] });
            }
        } catch (error) {
            if (error?.response?.data?.error) {
                toastr.error(error?.response?.data?.error);
                return;
            }
        } finally {
            setLoading(false);
        }
    }, [value, id, setVisible, getDataPost]);

    const handleOnClick = () => {
        postNewsFeed();
    };

    return (
        <>
            <Modal
                open={visible}
                title="Thêm bài viết"
                onCancel={() => setVisible(false)}
                footer={null}
                destroyOnHidden
                transitionName=""
                maskTransitionName=""
                modalRender={(modal) => (
                    <div
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1000,
                            minWidth: 600,
                        }}
                    >
                        {modal}
                    </div>
                )}
            >
                <div style={{ minWidth: 600 }}>
                    <RichEditor value={value} setValue={setValue} />
                </div>
                <Button
                    type="primary"
                    style={{ marginTop: "10px" }}
                    onClick={handleOnClick}
                    disabled={loading}
                    loading={loading}
                >
                    Thêm bài viết
                </Button>
            </Modal>
        </>
    );
}

export default ActionPostNewsFeed;
